export default "__VITE_ASSET__0b9e9fa4__"